import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Button, Checkbox, Grid2 as Grid, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ColDef, EditableCallbackParams } from "ag-grid-enterprise";
import { useState } from "react";
import { CatalogMaterial } from "../../../models/CatalogMaterial";
import { useCatalogMaterialContext } from "../CatalogMaterialContext";
const useStyles = makeStyles((theme: Theme) => ({
	buttons: {
		opacity: 0,
		transition: "opacity 0.1s ease-in-out",
		".ag-row-hover &": {
			opacity: 1,
		},
		".ag-row-focus &": {
			opacity: 1,
		},
		".ag-row-selected &": {
			opacity: 1,
		},
	},
}));
const CheckboxRenderer = (params: any) => {
	return <Checkbox checked={params.value} disabled={true} />;
};
const cellStyle = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};
type Props = {
	setMaterialId: Function;
	setShowEditModal: Function;
	setShowDeleteModal: Function;
	showContextMenu: Function;
};
export const useTableData = ({
	setMaterialId,
	setShowEditModal,
	setShowDeleteModal,
	showContextMenu,
}: Props) => {
	const { state } = useCatalogMaterialContext();
	const classes = useStyles();
	const rows: CatalogMaterial[] =
		state.materials?.map((material) => ({
			...material,
		})) || [];
	const [columnDefs] = useState<ColDef[]>([
		{
			field: "MaterialName",
			headerName: "Name",
			minWidth: 20,
			flex: 3,
			cellStyle: cellStyle,
		},
		{
			field: "L1MaterialId",
			headerName: "L1 Material ID",
			minWidth: 20,
			flex: 1,
			cellStyle: cellStyle,
		},
		{
			field: "IsAlloy",
			headerName: "Is Alloy",
			minWidth: 20,
			flex: 1,
			cellRenderer: CheckboxRenderer,
			cellStyle: cellStyle,
		},
		{
			field: "UseInEAF",
			headerName: "Use in EAF",
			minWidth: 20,
			flex: 1,
			cellRenderer: CheckboxRenderer,
			cellStyle: cellStyle,
		},
		{
			field: "UseInTrim",
			headerName: "Use in Trim",
			minWidth: 20,
			flex: 1,
			cellRenderer: CheckboxRenderer,
			cellStyle: cellStyle,
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						className={classes.buttons}
					>
						<Grid
							size={{ xs: 12 }}
							style={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
							}}
						>
							<Button
								onClick={() => {
									(async () => {
										setMaterialId(params.data.MaterialId);
										setShowEditModal(true);
									})();
								}}
							>
								<EditIcon style={{ height: "auto" }} color="primary" />
							</Button>
							<Button
								onClick={() => {
									(async () => {
										setMaterialId(params.data.MaterialId);
										setShowDeleteModal(true);
									})();
								}}
							>
								<DeleteIcon style={{ height: "auto" }} color="error" />
							</Button>
							<Button
								style={{}}
								onClick={(e) =>
									showContextMenu(e, params.data, "catMaterialsTable")
								}
							>
								<FormatListBulletedSharpIcon
									style={{ height: "auto" }}
									color="action"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			minWidth: 330,
			maxWidth: 380,
			filter: false,
			autoHeaderHeight: true,
		},
	]);

	return { rows, columnDefs };
};
